import { render } from "./CreateNewRescheduleForm.vue?vue&type=template&id=387b242a"
import script from "./CreateNewRescheduleForm.vue?vue&type=script&lang=js"
export * from "./CreateNewRescheduleForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__